<template>
  <button
    v-tooltip="title"
    class="ms-button btn"
    :class="[
      type,
      text ? '' : 'only-icon',
      radius ? 'btn-radius' : '',
      disabled ? 'disabled-icon' : '',
    ]"
    :disabled="disabled || processing"
  >
    <div
      v-if="leftIcon"
      :class="[`icon${iconSize} icon left`, leftIcon, disabled ? 'disabled-icon' : '']"
    />
    <div
      v-if="text"
      class="text"
      :class="[{ 'pl-0': leftIcon, 'pr-0': rightIcon }]"
    >
      {{ text }}
    </div>
    <div
      v-if="rightIcon"
      :class="[`icon${iconSize} icon right`, rightIcon, disabled ? 'disabled-icon' : '']"
    />
    <div
      v-if="$slots.default"
      class="ms-button-text ms-button--text flex align-center"
    >
      <slot />
    </div>
  </button>
</template>
<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'MsButton',
  props: {
    // tooltip hiển thị
    title: {
      default: null,
      type: String,
    },
    // Text hiển thị
    text: {
      default: null,
      type: String,
    },
    // Icon trái
    leftIcon: {
      default: null,
      type: String,
    },
    // Icon phải
    rightIcon: {
      default: null,
      type: String,
    },
    // Loại button gồm các loại primary/secondary/outline để hiện thị style tương ứng
    type: {
      default: 'primary',
      type: String,
    },
    /**
     * Cờ đánh dấu đang xử lý
     */
    processing: {
      default: false,
      type: Boolean,
    },
    radius: {
      default: false,
      type: Boolean,
    },
    // Kích thước icon 16/20/24/32
    iconSize: {
      type: [Number, String],
      default: 24,
    },
  },
})
</script>
<style scoped lang="scss">
@import '@/assets/scss/components/MsButton.scss';
</style>
